import { Flex, Skeleton } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { formatTranslation } from "../../../../shared/utils/translationUtils";

const DrawerSkeleton: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div style={{ marginTop: "30px" }} className="drawer-skeleton">
      <p style={{ fontWeight: "600", fontSize: "16px" }}>
        {formatTranslation(t("autozones.drawer.index.title"))}
      </p>
      {/* <Skeleton.Input active={true} style={{ height: "15px" }} />
      <Skeleton.Input active={true} style={{ height: "10px" }} /> */}
      <Flex
        style={{ margin: "20px 0px" }}
        gap="5px"
        flex={1}
        vertical={true}
        justify="space-between"
      >
        <Skeleton.Input active={true} block />
        <Skeleton.Input active={true} block />
        <Skeleton.Input active={true} block />
      </Flex>
      <div style={{ margin: "20px 0px" }}>
        <Skeleton.Input active={true} style={{ height: "15px" }} />
        <Skeleton.Input active={true} block />
      </div>
      <div>
        <Skeleton.Input active={true} style={{ height: "15px" }} />
        <Skeleton.Input active={true} block />
      </div>
      <div style={{ marginTop: "10px" }}>
        <Skeleton.Input active={true} block />
      </div>
    </div>
  );
};

export default DrawerSkeleton;
